import { render, staticRenderFns } from "./dangerPagination.vue?vue&type=template&id=214f3b4b&"
import script from "./dangerPagination.vue?vue&type=script&lang=js&"
export * from "./dangerPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports